import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#f7e21e',
    },
    secondary: {
      main: '#FF6D01',
    },
  },
});

export default theme;
